import { render } from "./WeeklyWiseScheduleComponent.vue?vue&type=template&id=2a544725&scoped=true"
import script from "./WeeklyWiseScheduleComponent.vue?vue&type=script&lang=js"
export * from "./WeeklyWiseScheduleComponent.vue?vue&type=script&lang=js"

import "./WeeklyWiseScheduleComponent.vue?vue&type=style&index=0&id=2a544725&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a544725"]])

export default __exports__